import { PROFILE_PREFIX } from 'constants';
import { useDetectDevice } from 'hooks/useDetectDevice';
import React, { useEffect } from 'react';
import { domUtils } from 'utils';
import useUploadDocuments from '../hooks/useUploadDocuments';

const withVerificationUploadDocumentsDrawerInitial = (Component) => {
  const VerificationUploadDocumentsDrawerComponent = (props) => {
    const { handleOnToggleNavbar } = props || {};

    const { isDesktop } = useDetectDevice();
    const { isUploadDocumentsTrigger } = useUploadDocuments();

    useEffect(() => {
      if (!isUploadDocumentsTrigger) return;
      handleOnToggleNavbar();
      domUtils.changeAddressBarUrlWithoutReloadPage({
        prefix: isDesktop ? `${PROFILE_PREFIX}` : `${PROFILE_PREFIX}?tab=0`,
      });
    }, []);

    const newProps = {
      ...props,
    };
    return <Component {...newProps} />;
  };
  return VerificationUploadDocumentsDrawerComponent;
};

export default withVerificationUploadDocumentsDrawerInitial;
